import uuid from 'react-uuid';

const STATE_UUID = `state-key-uuid_${process.env.REACT_APP_ID}`;

const getStateUuid = (): string | null => sessionStorage.getItem(STATE_UUID);

const setStateUuid = (value: string): void => sessionStorage.setItem(STATE_UUID, value);
const clearStateUuid = (): void => sessionStorage.removeItem(STATE_UUID);

const getStateKey = () => {
  if (getStateUuid()) {
    return getStateUuid();
  }

  const key = uuid();
  setStateUuid(key);

  return key;
};

const parseStateWithCampaign = (state: string | null) => {
  if (!state) {
    return { parsedState: null, campaign: null };
  }
  if (!state.includes(':')) {
    return { parsedState: state, campaign: null }; // No hay separador
  }
  const [parsedState, campaign] = state.split(':');
  return { parsedState, campaign };
};

export { getStateKey, clearStateUuid, parseStateWithCampaign };
